import { render } from "./PaymentStatusPage.vue?vue&type=template&id=ca5b5e40&scoped=true"
import script from "./PaymentStatusPage.vue?vue&type=script&lang=js"
export * from "./PaymentStatusPage.vue?vue&type=script&lang=js"

import "./PaymentStatusPage.vue?vue&type=style&index=0&id=ca5b5e40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5b5e40"]])

export default __exports__